import axios from 'axios';

export const getTokenRequest = (tokenId: string) => axios({
    method: 'post',
    url: `/api/auth`,
    headers: {
        'Content-Type': 'application/json',
    },
    data: {
        tokenId,
    },
});
